import { NavLink } from "@mantine/core";
import {
  IconActivity,
  IconChevronRight,
  IconBrandBooking,
  IconPicnicTable,
  IconUsersGroup,
  IconSettings,
  IconCalendar,
  IconFileImport,
} from "@tabler/icons-react";
import { RouteHeaderName } from "../skeleton.helper";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdminOrOwner } from "../../../../redux/selectors/authSelector";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isAdminOrOwner = useSelector(selectIsAdminOrOwner);
  const navBarItems = [
    {
      label: RouteHeaderName.Dashboard,
      icon: IconActivity,
    },
    {
      label: RouteHeaderName.Calendar,
      icon: IconCalendar,
    },
    {
      label: RouteHeaderName.Bookings,
      icon: IconBrandBooking,
    },
    {
      label: RouteHeaderName.Settings,
      icon: IconSettings,
    },
    {
      label: RouteHeaderName.Content,
      icon: IconBrandBooking,
    },
    {
      label: RouteHeaderName.Users,
      icon: IconUsersGroup,
    },
    {
      label: RouteHeaderName.ImportBookings,
      icon: IconFileImport,
    },
    {
      label: RouteHeaderName.Theaters,
      icon: IconPicnicTable,
    },
  ];

  return (
    <>
      {navBarItems.map((item, index) => (
        <NavLink
          key={index}
          label={item.label}
          leftSection={<item.icon size="1rem" stroke={1.5} />}
          disabled={item.label === RouteHeaderName.Content && !isAdminOrOwner}
          rightSection={
            <IconChevronRight
              size="0.8rem"
              stroke={1.5}
              className="mantine-rotate-rtl"
            />
          }
          variant="subtle"
          active={location.pathname?.split('/')?.pop() === item.label.toLowerCase()}
          onClick={() => {
            navigate(item.label.toLowerCase());
          }}
          styles={{
            root: {
              borderRadius: "0.5rem",
            },
            label: {
              fontSize: "1rem",
              fontWeight: "bold",
              borderBottom: "1px solid #e0e0e0",
            },
          }}
        />
      ))}
    </>
  );
};

export default Navbar;
